import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { POST } from '../../util/http'
import ComTable from '../../components/com-table/com-table'
import ComPagination from '../../components/com-pagination/com-pagination'
import './property.less'

const columns = [
  { label: '电摩编号', prop: 'vcu', width: '2' },
  { label: '资产型号', prop: 'propertyType', width: '1.2' },
  { label: '资产详情', width: '1.2', render: (data) => 
    <div>
      <span className='detail-btn' data-type="detail">查看</span>
    </div>
  }
]

const Property = () => {
  const router = useHistory();
  const [state, setState] = useState({
    listData: [],
    page: 1,
    pageSize: 10,
    total: 0
  })

  useEffect(() => {
    getTableData();
  }, [state.page])

  const setData = (obj={}) => {
    setState(st => ({ ...st, ...obj }));
  }
  const getTableData = async () => {
    let { page, pageSize } = state;
    const res = await POST('gePropertyList', { page, pageSize });
    let { list, total } = res.data || {};
    setData({ listData: list||[], total: total||0 });
  }
  const tableChange =(current) => {
    setData({ page: current });
  }
  const tabClick = (e, data) => {
    if (e.target.dataset.type != 'detail') return;
    router.push({ pathname: '/propertyDetail', state: { id: data.id } });
  }

  return (
    <div className="property-wrap">
      <div className="table-box">
        <ComTable columns={columns} datas={state.listData} center={true} rowClick={tabClick}></ComTable>
        <ComPagination className="rcg-pagination" currentPage={state.page} pageSize={state.pageSize} total={state.total} layout="total" change={e => tableChange(e)}></ComPagination>
      </div>
    </div>
  )
}

export default Property;